export enum AccountMutationTypes {
  SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER',
}
